import { render, staticRenderFns } from "./topicOperation.vue?vue&type=template&id=0845af94&scoped=true&"
import script from "./topicOperation.vue?vue&type=script&lang=js&"
export * from "./topicOperation.vue?vue&type=script&lang=js&"
import style0 from "./topicOperation.vue?vue&type=style&index=0&id=0845af94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0845af94",
  null
  
)

export default component.exports